import { useEffect, useState } from "react";
import { useRouter } from "next/router";

export const useCurrentPage = () => {
  const [currentPage, setCurrentPage] = useState(1);

  const router = useRouter();

  useEffect(() => {
    let { page } = router.query;

    if (Number(page)) {
      setCurrentPage(parseInt(page));
    } else {
      setCurrentPage(1);
    }
  }, [router]);

  return { currentPage };
};
